import { PortfolioConfig } from './types';

export const portfolioConfig: PortfolioConfig = {
  title: 'Benjamin Gregory - Portfolio',
  shortName: 'Benjamin Gregory',
  description: 'Personal portfolio of Benjamin Gregory.',
  developer: {
    name: 'Benjamin Gregory',
    url: 'https://github.com/benjamin-gregory/portfolio-website',
  },

  fullName: 'Benjamin Gregory',
  bio: 'Hi! I have B.S. in Computer Science with a minor in Data Science from Lafayette College with an interest in puzzle solving, math, and linguistics. My career experience includes embedded system and machine learning infrastructure, using a wide range of tools and frameworks. In addition to my passion for software engineering, my interests include cooking, crafting, and good stories. I take an equally analytical, creative, and curious perspective to all my pursuits and hobbies, where every challenge becomes a meaningful, intellectual pursuit.',

  githubUrl: 'https://github.com/benjamin-gregory',
  linkedinUrl: 'https://www.linkedin.com/in/benjaminxgregory',

  resumeSource: 'local',
  resumeLocation: 'benjamin_gregory_resume_20251029-redacted.pdf',
  resumeDownloadFilename: 'Benjamin_Gregory_Resume.pdf',

  timeline: [
    {
      id: '1',
      title: 'Internship with Embeddeers GmbH',
      description: 'Requirements engineering and software development according to ISO 15504 using the V-model. Using processes, verification, and different levels of validation to develop software that meets the highest quality standards and is suitable for use in safety-critical applications. Managed the integration of Volkswagen development requirements into the current development process.',
      location: 'Berlin, Germany',
      startDate: '2023-05-31',
      endDate: '2023-07-18',
      link: 'https://www.embeddeers.com/en/',
    },
    {
      id: '2',
      title: 'BS in Computer Science at Lafayette College',
      description: 'Expected Graduation in May, 2025',
      location: 'Easton, PA',
      startDate: '2021-08-31',
      endDate: '2025-05-24',
      link: 'https://www.lafayette.edu/',
    },
    {
      id: '3',
      title: 'Solebury Prepatory High School Graduation',
      description: 'Studied at a small performing arts focused prepatory high school',
      location: 'New Hope, PA',
      startDate: '2018-08-26',
      endDate: '2021-05-25',
      link: 'https://www.solebury.org/',
    },
    {
      id: '4',
      title: 'Volunteer English Tutor Abroad',
      description: 'Traveled to Costa Rica with a school sponsored program, volunteering as an English tutor serving underprivileged Spanish-speaking community.',
      location: 'Guanacaste, Costa Rica',
      startDate: '2018-03-25',
      endDate: '2018-04-03',
      link: 'https://abriendomentes.org/',
    },
    {
      id: '5',
      title: 'Data Structures and Algorithms Tutor',
      description: 'Providing peer tutoring support for classmates studying data structures and algorithms with Java and Object Oriented Techniques while coaching peers to develop study skills for success as Computer Science majors.',
      location: 'Easton, PA',
      startDate: '2023-08-30',
      endDate: '2024-01-01',
    },
    {
      id: '6',
      title: 'Commercial Data Science Intern, Bristol Myers Squibb',
      description: 'Collaborating to provide engineering support for Commercialization Data Science and AI Predictive Solutions. Supported the engineering of upstream data science pipelines to enhance workflow efficiency and model performance. Analyzed unexplored datasets to identify potential impacts, optimize existing modeling approaches, and develop strategic recommendations for improvement.',
      location: 'Lawrenceville, New Jersey',
      startDate: '2024-05-20',
      endDate: '2024-08-16',
    },
  ],

  projects: [
    {
      id: '1',
      title: 'Java Text Editor',
      repoUrl: 'https://github.com/benjamin-gregory/TextEditor',
    },
    {
      id: '2',
      title: 'General Sudoku Solver',
      repoUrl: 'https://github.com/benjamin-gregory/sudoku-solver',
    },
    {
      id: '3',
      title: 'Linear Algebra Utilities',
      repoUrl: 'https://github.com/benjamin-gregory/linear-algebra-utils',
    },
    {
      id: '4',
      title: 'Tafl-Game Engine and Utilities',
      repoUrl: 'https://github.com/benjamin-gregory/tafl-game-engine',
    },
    {
      id: '5',
      title: 'Updating Moscow SML Implementation of Uscheme Interpreter',
      repoUrl: 'https://github.com/benjamin-gregory/editing-mosml-uscheme-interpreter',
    },
    {
      id: '6',
      title: 'Custom Unix Shell',
      repoUrl: 'https://github.com/benjamin-gregory/custom-unix-shell',
    },
    {
      id: '7',
      title: 'Property Record Web Scraping',
      repoUrl: 'https://github.com/benjamin-gregory/property-record-web-scraping',
    },
    {
      id: '8',
      title: 'Personal Portfolio Website',
      repoUrl: 'https://github.com/benjamin-gregory/portfolio-website',
    },
    {
      id: '9',
      title: 'Retro-Chip React Component',
      repoUrl: 'https://github.com/benjamin-gregory/tech-logo-animation',
    },
    {
      id: '10',
      title: 'Discord Bot for LeetCode Challenges',
      repoUrl: 'https://github.com/benjamin-gregory/leetcode-discord-bot',
    },
  ],
};

export default portfolioConfig;
